// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--1KGRj","dropdownHoverArea":"styles-module--dropdownHoverArea--2jIc8","dropdownWhiteBox":"styles-module--dropdownWhiteBox--2_S0n"};